module.exports = __webpack_public_path__ + "static/img/logo.42c582c8.png";